export default __webpack_public_path__ + "static/media/audio_sprite_master.1943798a.mp3";